import React from 'react';
import { Link } from 'react-router-dom';
import type { NavItemType } from '../../types/navigation';

interface NavItemProps {
  item: NavItemType;
  isActive: boolean;
  isMobile?: boolean;
  onClick?: () => void;
}

export const NavItem: React.FC<NavItemProps> = ({ 
  item, 
  isActive, 
  isMobile = false,
  onClick 
}) => {
  const mobileClasses = `block px-4 py-2 text-sm ${
    isActive
      ? 'bg-blue-50 text-blue-600'
      : 'text-gray-700 hover:bg-gray-50'
  }`;

  const desktopClasses = `text-sm font-medium ${
    isActive
      ? 'text-blue-600'
      : 'text-gray-500 hover:text-gray-900'
  }`;

  return (
    <Link
      to={item.path}
      className={isMobile ? mobileClasses : desktopClasses}
      onClick={onClick}
    >
      {item.label}
    </Link>
  );
};